import $ from 'jquery'
import ImagesLoaded  from 'Imagesloaded'
import 'sumoselect'

export default {
  init() {

    const form = $('form.product-filter')
    const wrapaper = $('.main-content')
    const productWrapaper  = $('.product-content > .products .row')    
    const filterButton = $('.product-filter__button')
    const loadMoreButton = $('.load-more-button')    
    const reset = $('.action-reset')
    const search = $('.action-search')
    const select = $('select')
    const collectionSelect = $('select#collection-select')
    const categorySelect = $('select#category-select')
    const artistSelect = $('select#artist-select')
    const orderbySelect = $('select#orderby-select')    
    const pageInput = $('#page-input')    
    const result = $('.product-filter-result')
    const rippleJS = $('<div class="rippleJS"></div>')
    const filterGroup = $('.product-filter__group')    

    let checkPushState = () => {
      if (!form.data('submit')) {
        form.data('submit', true)
        window.history.pushState( 
          {
            category: categorySelect.val(),
            collection: collectionSelect.val(),
            artist: artistSelect.val(),
            orderby: orderbySelect.val()
          }, 
          null, 
          window.location.href
        )
      }
    }

    form.submit(function(event) {

      event.preventDefault()

      wrapaper.addClass('is-loading')

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: JWD.ajaxurl,
        data: form.serialize(),
        success : function( data ){

          wrapaper.removeClass('is-loading')

          result.html(data.result)
          if ( data.page > 1 ) {
            productWrapaper.append(data.product)
          } else {
            productWrapaper.html(data.product)

            if ($(window).outerWidth() > 1199) {
              $('html, body').animate({
                scrollTop: 200
              }, 800, 'easeOutQuart')
            }

            $('title').html(data.tag_title)
            $('.page-title').html(data.title)

            if (!form.hasClass('is-popstate')) {
              window.history.pushState( 
                {
                  category: data.category,
                  collection: data.collection,
                  artist: data.artist,
                  orderby: data.orderby
                },
                null,
                data.url 
              )
            }
            form.removeClass('is-popstate')
          }

          if (data.page >= data.page_total) {
            loadMoreButton.addClass('d-none')
          } else {
            loadMoreButton.removeClass('d-none')
          }

          loadMoreButton.removeClass('is-loading')

        },
        complete: function(data){
          
          $('.jwd-lazyload.is-loading').each(function(index, el) {
            var t = $(this);
      
            ImagesLoaded(t, ()=> {
              t.find('img').attr('src', t.find('img').data('src') )
              t.removeClass('is-loading')
            })
      
          })

          search.removeClass('is-loading')
          $('html').removeClass('open-filter')
        },
        error : function( err ){}

      });

    })
    
    select.SumoSelect()

    $('.SumoSelect .SelectBox').append(rippleJS)

    select.on('sumo:opening', function(sumo) {
      checkPushState()
    });

    categorySelect.on('change', (event) => {

      collectionSelect.empty()
      collectionSelect.closest(filterGroup).addClass('d-none')
      artistSelect.closest(filterGroup).removeClass('d-none')

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: `${JWD.api_endpoint}v1/product/category`,
        data: {category : event.target.value, lang: $('input[name="lang"]').val() },
        success : function(data){

          if (data) {
            collectionSelect.html(data)
            collectionSelect.closest(filterGroup).removeClass('d-none')
            collectionSelect[0].sumo.reload()
            collectionSelect.next().append(rippleJS)
          }

        },
        complete: function(data){

        },
        error : function( err ){}

      })
    })

    collectionSelect.on('change', (event) => {

      if (event.target.value === 'jeff-koons') {
        artistSelect.closest('.product-filter__group').addClass('d-none')
        artistSelect.val('')
        artistSelect[0].sumo.reload()
      } else {
        artistSelect.closest('.product-filter__group').removeClass('d-none')
      }

    })

    select.on('focus', () => {

      checkPushState()

    }).change(() => {

      $('html, body').on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", ()=> {
        $('html, body').stop();
      })

      wrapaper.addClass('is-loading')
      pageInput.val(1)
      form.submit()

    })
    
    loadMoreButton.on('click', function() {
      $(this).addClass('is-loading')
      pageInput.val(parseInt(pageInput.val()) + 1)
      form.submit()
    });

    search.click(function(){
      $(this).addClass('is-loading')
      form.submit()
    })
    
    filterButton.click(function(){
      $(this).toggleClass('is-active')
      $(this).next().slideToggle(300)
    })    

    if ( history.pushState ) {
      window.addEventListener('popstate', (event) => {

        if(window.history.state) {
          form.addClass('is-popstate')
          
          if(event.state.category) {
            categorySelect.val(event.state.category) 
          } else {
            categorySelect.val('') 
          }

          if(event.state.collection) {
            collectionSelect.val(event.state.collection) 
          } else {
            collectionSelect.val('') 
          }

          if(event.state.artist) {
            artistSelect.val(event.state.artist) 
          } else {
            artistSelect.val('') 
          }

          if(event.state.orderby) {
            orderbySelect.val(event.state.orderby) 
          }
          
          select[0].sumo.reload()
          
          form.submit()
        }
      })
    }
  },

  finalize() {
    window.onload = function() {
      new Waypoint({
        element: $('.woocommerce-products-header'),
        handler: function() {
          $(this.element).toggleClass('is-sticky')
        },
        offset: '80px'
      })
    }
  },
};
